<template>
  <div id="segment-products">
    <div v-if="load || error" class="response-handle d-flex align-center justify-center">
      <Loader v-if="load"/>
      <error v-if="error" />
    </div>
    <div  id="carousel" v-if="!load && !error">
      <div class="segment-header">
        <div :class="[this.$lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en', 'segment-title']">{{$t('segmentedProducts.sliderTitle')}}</div>
        <div :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en', 'description']">
          {{$t('segmentedProducts.sliderDesc')}}
        </div>
      </div>
      <VueSlickCarousel  @beforeChange="changePage"  v-show="slidesToShow < slider.length" ref="slider" v-bind="settings" :rtl="this.$lang === 'ar' ? true : false" :arrows="false" :dots="false">
        <div @click="handleClick(index)" :style="{width: currentSlide === index ? width.current : width.slide}" class="my-slide" v-for="(data, index) in slider" :key="index">
          <div @mouseenter="handleAnimation(index)" @mouseleave="removeAnimation(index)" class="slide-container" :style="{background: `url(${data.img})`}">
            <div v-if="currentSlide !== index" class="segment-info">
              <div class="data-title">
                <div :style="index !== currentSlide ? { width: '35px' } : { width: '80px'}" class="line"></div>
                <div :class="[lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en', 'data-head px-2']">{{data.title}}</div>
              </div>
            </div>

            <div v-if="currentSlide === index" class="hovered-segment-info">
              <div class="data-title">
                <div :style="index !== currentSlide ? { width: '35px' } : { width: lineWidth.current}" class="line"></div>
                <div :class="[lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en', 'data-head']">{{data.title}}</div>
              </div>
              <div v-if="index === currentSlide" class="wrapper">
                <div class="inner">
                  <div :style="{opacity: show ? 1 : 0}" :class="[lang === 'ar' ? 'regular-ar padding-ar' : 'regular-en padding-en', 'data-desc']">{{data.info}}</div>
                  <div :style="{opacity: show ? 1 : 0}" :class="[lang === 'ar' ? 'padding-ar' : 'padding-en' ,'data-btn']">
                    <router-link :to="`/segment-details/${data.id}`">
                      <a>
                        <span :class="lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en'">{{ $t('checkAll') }}</span>
                        <img :class="[lang === 'ar' && 'rotate' ,'px-2']" src="../../assets/icons/yellow-arrows.svg">
                      </a>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <div :style=" index !== currentSlide ? { display: 'block' } : { display: 'none' } " class="layer"></div>
          </div>
        </div>
      </VueSlickCarousel>
      <div v-if="slidesToShow >= slider.length" class="special-case d-flex">
        <div @mouseenter="handleAnimation(index, 'special')" @mouseleave="removeAnimation(index, 'special')" v-for="(data, index) in slider" :key="index" class="slide-container" :style="{background: `url(${data.img})`}">
          <div :id="`data-${index}`" :class="[lang === 'ar' ? 'right-dir' : '', 'hovered-segment-info']">
            <div class="data-title">
              <div :style="{ width: lineWidth.current}" class="line"></div>
              <div :class="[lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en', 'data-head']">{{data.title}}</div>
            </div>
            <div class="wrapper">
              <div class="inner">
                <div :style="{opacity: show ? 1 : 0}" :class="[lang === 'ar' ? 'regular-ar padding-ar' : 'regular-en padding-en', 'data-desc']">{{data.info}}</div>
                <div :style="{opacity: show ? 1 : 0}" :class="[lang === 'ar' ? 'padding-ar' : 'padding-en' ,'data-btn']">
                 <router-link :to="`/segment-details/${data.id}`">
                   <a>
                     <span :class="lang === 'ar' ? 'bold-italic-ar' : 'bold-italic-en'">{{ $t('checkAll') }}</span>
                     <img :class="[lang === 'ar' && 'rotate' ,'px-2']" src="../../assets/icons/yellow-arrows.svg">
                   </a>
                 </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="slidesToShow < slider.length" :class="[this.$lang === 'ar' && 'flex-row-reverse', 'segment-pagination']">
        <div  :class="[this.$lang === 'ar' ? 'regular-ar flex-row-reverse': 'regular-en', 'numbers']">
          <div class="current">
            <span v-if="currentSlide.toString().length === 1">0</span>
            <span>{{currentSlide + 1}}</span>
          </div>
          <div :class="[this.$lang === 'ar' && 'd-flex flex-row-reverse', 'total']">
            <span>/</span>
            <span>
            <span v-if="slider.length.toString().length === 1">0</span>
            <span>{{ slider.length }}</span>
          </span>
          </div>
        </div>
        <div :class="[this.$lang === 'ar' && 'flex-row-reverse', 'buttons d-flex']">
          <div @click="handlePrev" id="prev" class="button mx-6">
            <img  :class="this.$lang !== 'ar' && 'rotate'" src="../../assets/icons/arrows.svg">
          </div>
          <div @click="handleNext" id="next" class="button next-btn">
            <img :class="this.$lang === 'ar' && 'rotate'" src="../../assets/icons/arrows.svg">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueSlickCarousel from 'vue-slick-carousel-rtl'
import 'vue-slick-carousel-rtl/dist/vue-slick-carousel-rtl.css'
import 'vue-slick-carousel-rtl/dist/vue-slick-carousel-theme.css'
import military from '../../assets/images/military.png'
import engineers from '../../assets/images/engineers.png'
import picnic from '../../assets/images/slider-img.png'
import doctors from '../../assets/images/slider-img2.png'
import AllSegments from '../../repositories/AllSegments'
import Loader from '../../components/LoaderBtn/Loader'
import Error from '../../components/errorHandle/Error'
import gc from '../../utils/gc'
import $ from 'jquery'
export default {
  components: { VueSlickCarousel, Loader, Error },
  data () {
    return {
      segmentRepo: new AllSegments(),
      lang: this.$lang,
      image: military,
      slider: [{ img: military, title: 'Military Lines', info: 'Special Needs Requires Special Offers, Neither You Are A Teacher , Student , Doctor , Soldier … We Got Your Back. Check For The Line That Suits You And Get All The Benefits From Our Offers And Bundles Which Are Made For You' }, { img: engineers, title: 'Students Lines' }, { img: picnic, title: 'Students Lines' }, { img: doctors, title: 'Students Lines' }],
      currentSlide: 0,
      componentKey: 0,
      settings: {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 250,
        initialSlide: 0,
        variableWidth: true,
        slidesToScroll: 1,
        touchThreshold: 5,
        spaceBetween: 0,
        responsive: [
          {
            breakpoint: 1750,
            settings: {
            }
          },
          {
            breakpoint: 1550,
            settings: {
            }
          },
          {
            breakpoint: 1350,
            settings: {
            }
          },
          {
            breakpoint: 1250,
            settings: {
            }
          },
          {
            breakpoint: 1000,
            settings: {
            }
          },
          {
            breakpoint: 800,
            settings: {
            }
          },
          {
            breakpoint: 550,
            settings: {
            }
          },
          {
            breakpoint: 480,
            settings: {
            }
          }
        ]
      },
      show: false,
      width: { current: '50vw', slide: '300px' },
      lineWidth: { current: '80px', line: '35px' },
      slidesToShow: 0,
      load: false,
      error: false
    }
  },
  mounted () {
    this.fetchData()
    this.handleWidth()
    this.$watch(() => {
      return this.$store.state.tab
    }, val => {
      if (!this.load && !this.error && val === 1) {
        setTimeout(() => {
          this.$refs.slider.goTo(0)
          setTimeout(() => {
            $('.slick-track').css('transform', 'unset')
          }, 250)
        })
      }
    })
    this.$watch(() => {
      return this.$store.state.window
    }, val => {
      if (!this.load && !this.error) {
        this.handleWidth()
        this.$forceUpdate()
      }
    })
  },
  methods: {
    async fetchData () {
      try {
        this.load = true
        const response = await this.segmentRepo.get()
        this.slider = []
        if (response.status === 200) {
          for (let i = 0; i < response.data.length; i++) {
            this.slider.push({ id: response.data[i].id, img: gc.baseUrl + '/' + response.data[i].image, title: response.data[i].title, info: response.data[i].description })
          }
          this.show = true
        } else {
          this.error = true
        }
      } catch (e) {
        this.error = true
        console.log(e)
      }
      this.load = false
    },
    changePage (old, next) {
      this.currentSlide = next
      this.$forceUpdate()
    },
    handleWidth () {
      this.lineWidth.current = this.$store.state.window <= 1280 && this.$store.state.window > 750 ? '60px' : this.$store.state.window <= 750 ? '50px' : '80px'
      this.width.current = this.$store.state.window < 480 ? '100vw' : this.$store.state.window >= 480 && this.$store.state.window < 800 ? '75vw' : this.$store.state.window >= 800 && this.$store.state.window < 1250 ? '60vw' : this.$store.state.window >= 1250 ? '50vw' : '80vw'
      this.width.slide = this.$store.state.window < 480 ? '100vw' : this.$store.state.window >= 550 && this.$store.state.window < 1000 ? '270px' : this.$store.state.window >= 1000 && this.$store.state.window < 1350 ? '275px' : this.$store.state.window >= 1350 && this.$store.state.window < 1550 ? '310px' : this.$store.state.window >= 1550 && this.$store.state.window < 1750 ? '350px' : this.$store.state.window >= 2500 ? '450px' : this.$store.state.window >= 1750 ? '370px' : '200px'
      this.slidesToShow = this.$store.state.window < 480 ? 1 : this.$store.state.window >= 480 && this.$store.state.window < 800 ? 2 : this.$store.state.window >= 800 && this.$store.state.window < 1250 ? 3 : this.$store.state.window >= 1250 && this.$store.state.window < 2500 ? 4 : 4
      this.$refs.slider.goTo(0)
    },
    handleAnimation (index, status = 'normal') {
      this.show = true
      if (index === this.currentSlide && status === 'normal') {
        $('.wrapper').addClass('is-hovered')
        $('.hovered-segment-info .data-title').css('padding-bottom', '1rem')
        $('.hovered-segment-info').addClass('hovered-background')
      } else if (status === 'special') {
        $(`#data-${index} .wrapper`).addClass('is-hovered')
        $(`#data-${index}.hovered-segment-info .data-title`).css('padding-bottom', '1rem')
        $(`#data-${index}.hovered-segment-info`).addClass('hovered-background')
      }
      this.$forceUpdate()
    },
    removeAnimation (index, status = 'normal') {
      this.show = false
      if (index === this.currentSlide) {
        $('.hovered-segment-info').removeClass('hovered-background')
        $('.hovered-segment-info .data-title').css('padding-bottom', '3rem')
        $('.wrapper').removeClass('is-hovered')
      } else if (status === 'special') {
        $(`#data-${index} .wrapper`).removeClass('is-hovered')
        $(`#data-${index}.hovered-segment-info .data-title`).css('padding-bottom', '3rem')
        $(`#data-${index}.hovered-segment-info`).removeClass('hovered-background')
      }
      this.$forceUpdate()
    },
    handleNext () {
      this.$refs.slider.next()
    },
    handlePrev () {
      this.$refs.slider.prev()
    },
    // handleRoute (id, type) {
    //   this.$router.push(`/segment-details/${id}`)
    // },
    handleClick (index) {
      if (index !== this.currentSlide) {
        this.$refs.slider.goTo(index)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/sass/main";
#segment-products{
  background: linear-gradient(45deg, rgb(242,242,242), rgb(255,255,255)) ;
  min-height: calc(100vh - (155px + 285.6px));
}
.response-handle{
  min-height: calc(100vh - (155px + 285.6px));
}
.rotate{
  transform: rotate(180deg);
}
.padding-en{
  padding-left: 90px;
}
.padding-ar{
  padding-right: 90px;
}
.segment-header{
  width: 95%;
  margin: 0rem auto;
  padding: 2rem 0;
}
.segment-title{
  font-size: 30px;
  color: $--yellow;
}
.description{
  font-size: 15px;
}
.slide-container{
  width: 100%;
  height: 450px;
  background-size: cover !important;
  //background-position: 100% 100% !important;
  background-position: center !important;
  position: relative;
}
.layer{
  width: 100%;
  height: 100%;
  position: absolute;
  background: rgb(29, 29, 29, .45);
  backdrop-filter: blur(3.5px);
}
.segment-info{
  position: absolute;
  z-index: 2;
  text-align: initial;
  width: 100%;
  left: 0;
  bottom: 0;
}
.hovered-segment-info{
  width: 100%;
  position: absolute;
  bottom: 0px;
}
.hovered-background{
  background-color: rgba(29,29,29,0.3);
  backdrop-filter: blur(16px);
  padding: 1.5rem 0;
}
.wrapper{
  display: grid;
  grid-template-rows: 0fr;
  transition: all 150ms ease-in-out;
}
.inner{
  overflow: hidden;
  width: 90%;
}
.is-hovered{
  grid-template-rows: 1fr;
}
.data-title{
  display: flex;
  align-items: center;
  padding-bottom: 3rem;
}
.data-head{
  color: $--yellow;
  font-size: 25px;
  padding: 0 10px;
}
.line{
  height: 2.5px;
  background-color: $--yellow;
}
.data-desc{
  color: #ffffff;
  //padding-left: 90px;
  text-align: initial;
  font-size: 13px;
}
.data-btn{
  display: flex;
  color: $--yellow;
  padding-top: 1rem;
  //padding: 1rem 0 0 90px;
  text-decoration: underline;
  font-size: 12px;
  cursor: pointer;
}
.data-btn > img {
  width: 30px;
}
.segment-pagination{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: .8rem 90px;
}
.button{
  height: 50px;
  width: 50px;
  border: 2px solid $--yellow;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.button > img{
  width: 15px;
}
.numbers{
  display: flex;
  align-items: flex-end;
  justify-content: center;
  color: $--yellow
}
.current{
  font-size: 35px;
}
.total{
  font-size: 22px;
  padding-bottom: 5px;
  opacity: 50%;
}
.special-case{
  margin-bottom: 4rem;
}
@media screen and (min-width: 550px ){
  .segment-header{
    width: 90%;
    padding: 2rem 0
  }
  .segment-title{
    font-size: 30px;
  }
  .description{
    font-size: 14px;
  }
}
@media screen and (min-width: 800px ){
  .segment-header{
    width: 80%;
  }
}
@media screen and (min-width: 1250px ){
  .segment-header{
    width: 60%;
  }
}
@media screen and (max-width: 750px){
  .padding-ar{
    padding-right: 60px;
  }
  .padding-en{
    padding-left: 60px;
  }
  .segment-pagination{
    padding: 0.8rem 5%
  }
}
@media (min-width: 750px) and (max-width: 1281px){
  .padding-ar{
    padding-right: 70px;
  }
  .padding-en{
    padding-left: 70px;
  }
  .segment-pagination{
    padding: 0.5rem 70px
  }
}
</style>
<!-- slider -->
<style lang="scss">
  #segment-products{
    .slick-slider.slick-initialized{
      height: 450px;
    }
  }
</style>
<!-- ------------------------------------- -->
